import { render, staticRenderFns } from "./AdminClientsPageOptions.vue?vue&type=template&id=c1b99d7e"
import script from "./AdminClientsPageOptions.vue?vue&type=script&lang=js"
export * from "./AdminClientsPageOptions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports